// Dashboard tile shapes are generated from OrbitalX.Dto — see api-generated.d.ts.
//
// Two things the generated file cannot say, and that callers still depend on:
//
// - `DashboardWindowCountDto.Previous` is null on All Time, where there is no preceding period —
//   so a delta must be hidden rather than rendered as zero.
// - A null section on `DashboardTileSectionsDto` means "could not be computed" and is named in
//   `FailedSections`. Render it as an error, not as an empty state.

import type { DashboardTilesDto as GeneratedDashboardTilesDto } from './api-generated'

export type {
  CampaignTrendPointDto,
  DashboardCampaignPerformanceItemDto,
  DashboardHottestCompanyItemDto,
  DashboardHottestLeadItemDto,
  DashboardNewestConversionItemDto,
  DashboardTileSectionsDto,
  DashboardTopPerformingWebItemDto,
  DashboardWindowCountDto,
} from './api-generated'

/**
 * The range token is a path segment on the dashboard endpoints. `AllTime` is the default and
 * resolves server-side to an unbounded window with no comparison period.
 */
export type DashboardRange = 'AllTime' | 'Days30' | 'Days60' | 'Days90'

export const DASHBOARD_RANGE_OPTIONS: { value: DashboardRange; label: string }[] = [
  { value: 'AllTime', label: 'All Time' },
  { value: 'Days30', label: 'Last 30 Days' },
  { value: 'Days60', label: 'Last 60 Days' },
  { value: 'Days90', label: 'Last 90 Days' },
]

/**
 * Every tile on a dashboard, from one server-side read.
 *
 * `Range` narrows the generated `string` to the tokens the endpoints accept. The DTO is stringly
 * typed on the C# side too, so the narrowing has to live here until ORB-752's follow-up teaches
 * the emitter which enum backs which property.
 */
export interface DashboardTilesDto extends Omit<GeneratedDashboardTilesDto, 'Range'> {
  Range: DashboardRange
}
